module.exports = __webpack_public_path__ + "img/Header_Om_oss.773c98b5.jpg";